import * as React from "react";
function LgIcon() {
    return React.createElement("path", { d: "M4.5 22.4994V8.4995H8.86535V9.99948H5.99997V20.9995H18V9.99948H15.1346V8.4995H19.5V22.4995L4.5 22.4994ZM11.25 15.7495V4.7187L9.39998 6.56873L8.34615 5.4995L12 1.8457L15.6538 5.4995L14.6 6.56873L12.75 4.7187V15.7495H11.25Z", fill: "currentColor" });
}
export default LgIcon;
//# sourceMappingURL=Lg.js.map